import { makeStyles } from "@mui/styles";
import { DataGridPro } from "@mui/x-data-grid-pro";
import React from "react";
import { SENIORITY_LIST_PAGE_TYPE } from "../util/constants";
import { getMobileViewColumns } from "../util/seniorityListUtils";
import CustomErrorTableOverlay from "./CustomErrorTableOverlay";
import customLoadingTableOverlay from "./CustomLoadingTableOverlay";
import CustomNoRowsTableOverlay from "./CustomNoRowsTableOverlay";
import { Box } from "@mui/material";
import SeniorityListDetailPanelContent from "./SeniorityListDetailPanelContent";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  collisionRow: {
    backgroundColor: theme.palette.secondary.swaLightRed + " !important",
  },
  gridStyle: (props) => ({
    borderRadius: 0,
    border: "none",
    "& div": {
      "& .MuiDataGrid-footerContainer": {
        display: "none",
      },
      "& .MuiDataGrid-columnSeparator": {
        display: "none",
      },
      "& .MuiDataGrid-columnHeaderTitle": {
        color: theme.palette.primary.swaBlue,
        fontWeight: "bold",
      },
      "& .MuiDataGrid-row ": {
        textAlign: "left",
      },
      "& .MuiDataGrid-cell ": {
        whiteSpace: "normal !important",
        wordWrap: "break-word !important",
      },
    },
  }),
  evenRow: {
    backgroundColor: theme.palette.secondary.swaGray1,
  },
  tempChip: {
    marginLeft: "5px",
  },
  mobileRoot: {
    width: "100%",
    overflowY: "scroll",
    textAlign: "left",
  },
  mobileGridScroll: {
    width: "100%",
    height: `calc(100% - 310px)`,
    overflowY: "scroll",
    position: "absolute",
    overflowX: "scroll",
  },
}));

const SeniorityListTableMobile = (props) => {
  const classes = useStyles();
  const [sortModel, setSortModel] = React.useState([
    {
      field: "rank",
      sort: "asc",
    },
  ]);

  const getDetailPanelHeight = React.useCallback(() => 100, []);
  const getDetailPanelContent = React.useCallback(
    ({ row }) => (
      <SeniorityListDetailPanelContent
        row={row}
        contract={props.contract}
        seniorityListType={props.seniorityListType}
        station={props.station}
        workgroup={props.workgroup}
      />
    ),
    [props.contract, props.seniorityListType, props.station, props.workgroup]
  );
  return (
    <div className={classes.mobileRoot}>
      <div>
        <Box
          sx={{
            height: "60vh",
            width: "100%",
          }}
        >
          <div className={classes.mobileGridScroll}>
            <DataGridPro
              className={classes.gridStyle}
              rows={props.seniorityList}
              apiRef={props.apiRef}
              columns={getMobileViewColumns(props)}
              rowKeyGetter={(row) => row.rank}
              getRowId={(row) => row.rank}
              disableColumnMenu={true}
              sortModel={sortModel}
              onSortModelChange={(event) => {
                setSortModel(event);
              }}
              rowHeight={50}
              components={{
                LoadingOverlay: customLoadingTableOverlay,
                NoRowsOverlay: CustomNoRowsTableOverlay,
                ErrorOverlay: CustomErrorTableOverlay,
              }}
              componentsProps={{
                noRowsOverlay: {
                  pageType: SENIORITY_LIST_PAGE_TYPE,
                  isEmployeeView: props.isEmployeeView,
                  seniorityListFtPtCount: props.seniorityListFtPtCount,
                },
                errorOverlay: {
                  errorMessage: props.errorObject.message,
                  errorCode: props.errorObject.code,
                },
              }}
              loading={props.isLoading}
              error={props.isError}
              ref={props.gridRef}
              getDetailPanelContent={getDetailPanelContent}
              getDetailPanelHeight={getDetailPanelHeight}
            />
          </div>
        </Box>
      </div>
    </div>
  );
};

SeniorityListTableMobile.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  gridRef: PropTypes.object.isRequired,
  errorObject: PropTypes.object.isRequired,
  isError: PropTypes.bool.isRequired,
  station: PropTypes.string.isRequired,
  contract: PropTypes.string.isRequired,
  workgroup: PropTypes.string.isRequired,
  isEmployeeView: PropTypes.bool.isRequired,
  apiRef: PropTypes.object.isRequired,
  seniorityList: PropTypes.array.isRequired,
  seniorityListType: PropTypes.string.isRequired,
};
export default SeniorityListTableMobile;
